export default {
  title: "",
  subtitle: "Brazilian Person Registration",
  path: "person_registration_br",
  paragraph: "For Brazil, the document_type is usually the CPF (a 11 digit-number), below you can check a payload sample for registration of a person in Brazil. For other requirements depending on payment methods, check the table 'Information needed for registration (Person)'",
  request: {
    payload: {
      "person": {
        "document_number": "70590071050",
        "document_type": "cpf",
        "social_name": "Joaquim dos Santos",
        "fiscal_country": "Brasil",
      }
    },
    responses: {
    "data": {
        "updated_at": "2025-07-09T13:51:30.989491",
        "status": "approved",
        "social_name": "Joaquim dos Santos",
        "rfc_pf": null,
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "phone_country_code": null,
        "phone_area_code": null,
        "net_monthly_average_income": null,
        "inserted_at": "2023-12-11T14:11:02.571103",
        "id": "5fd0aa81-b427-4a29-9968-6491d1d7f8b0",
        "fiscal_country": "Brasil",
        "email": null,
        "documents": [],
        "document_type": "cpf",
        "document_number": "70590071050",
        "clearance_level": 1,
        "birth_date": null,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_neighborhood": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonRegistrationBR.js